<div class="demo-container">
  <div class="demo-header">
    <h1>Custom Date Picker Demo</h1>
    <p>Showcasing the new modern date picker component with clean UI design</p>
  </div>

  <form [formGroup]="demoForm" (ngSubmit)="onSubmit()" class="demo-form">
    <div class="demo-section">
      <h2>Basic Date Picker</h2>
      <div class="form-group">
        <label>Select a date:</label>
        <app-custom-date-picker 
          formControlName="basicDate"
          placeholder="Pick Date"
          (dateChange)="onDateChange($event)">
        </app-custom-date-picker>
      </div>
    </div>

    <div class="demo-section">
      <h2>Date Picker with Min/Max Date</h2>
      <div class="form-group">
        <label>Select date between 2020-2030:</label>
        <app-custom-date-picker 
          formControlName="withMinMax"
          placeholder="Pick Date"
          [minDate]="minDate"
          [maxDate]="maxDate"
          (dateChange)="onDateChange($event)">
        </app-custom-date-picker>
      </div>
    </div>

    <div class="demo-section">
      <h2>Disabled Date Picker</h2>
      <div class="form-group">
        <label>Disabled date picker:</label>
        <app-custom-date-picker 
          formControlName="disabledDate"
          placeholder="Pick Date"
          [disabled]="true">
        </app-custom-date-picker>
      </div>
    </div>

    <div class="demo-section">
      <h2>Custom Placeholder</h2>
      <div class="form-group">
        <label>Custom placeholder text:</label>
        <app-custom-date-picker 
          formControlName="customPlaceholder"
          placeholder="Choose your preferred date"
          (dateChange)="onDateChange($event)">
        </app-custom-date-picker>
      </div>
    </div>

    <div class="demo-section">
      <h2>Custom Year Picker</h2>
      <div class="form-group">
        <label>Select a year:</label>
        <app-custome-year-picker 
          formControlName="yearPicker"
          placeholder="Pick Year"
          [minYear]="2020"
          [maxYear]="2030"
          (yearChange)="onYearChange($event)">
        </app-custome-year-picker>
      </div>
    </div>

    <div class="demo-section">
      <h2>Form Values</h2>
      <div class="form-values">
        <pre>{{ demoForm.value | json }}</pre>
      </div>
    </div>

    <div class="demo-actions">
      <button type="submit" class="btn btn-primary">Submit Form</button>
      <button type="button" class="btn btn-secondary" (click)="demoForm.reset()">Reset Form</button>
    </div>
  </form>
</div> 